import { faHeart } from '@fortawesome/pro-light-svg-icons';
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import useToggleFavorite, {
  ToggleFavoriteInput,
} from '../../../hooks/api/mutations/useToggleFavorite';
import useFavorites from '../../../hooks/api/queries/useFavorites';
import useJwt from '../../../hooks/utils/useJwt';
import { __ } from '../../../i18n/l10n';
import { SLUG_FAVORITES } from '../../../styles/slugs';
import { theme } from '../../../styles/theme';
import { Toast } from '../toast/Toast';

interface Props {
  productId: number;
  big?: boolean;
}

export const FavoriteIcon = ({ productId, big = false }: Props) => {
  const { data } = useFavorites();
  const isFavorite = data?.includes(productId);
  const jwt = useJwt();

  const toggleFavoriteInput: ToggleFavoriteInput = {
    jwt,
    productId,
    action: isFavorite ? 'remove' : 'add',
  };

  const { mutate } = useToggleFavorite();

  if (!jwt) return null;
  return (
    <Icon
      $big={big}
      onClick={() => {
        mutate(toggleFavoriteInput);
        !isFavorite &&
          toast(({ closeToast, toastProps }) => (
            <Toast
              label={__('Product added to favorites')}
              link={`/${SLUG_FAVORITES}`}
              closeToast={closeToast}
              toastProps={toastProps}
            />
          ));
      }}
    >
      {isFavorite ? (
        <FontAwesomeIcon
          icon={faHeartSolid}
          color={theme.colors.red}
          size={'xs'}
        />
      ) : (
        <div>
          <FontAwesomeIcon
            icon={faHeart}
            color={theme.colors.red}
            size={'xs'}
          />
          <FontAwesomeIcon
            icon={faHeartSolid}
            color={theme.colors.red}
            size={'xs'}
          />
        </div>
      )}
    </Icon>
  );
};

const Icon = styled.div<{ $big: boolean }>`
  cursor: pointer;
  width: ${({ $big }) => ($big ? '34px' : '28px')};
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};

  > div {
    > :last-child {
      display: none;
    }
  }

  &:hover {
    > div {
      > :first-child {
        display: none;
      }
      > :last-child {
        display: block;
      }
    }
  }

  svg {
    vertical-align: -0.1em !important;
  }
`;
